import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["value", "extension"];
import { c as _c } from "react-compiler-runtime";
import { useContext } from 'react';
import formatPhoneNumber from 'I18n/utils/formatPhoneNumber';
// @ts-ignore untyped JS module
import formatPhoneNumberWithExtension from 'I18n/utils/formatPhoneNumberWithExtension';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
function FormattedPhoneNumber(t0) {
  const $ = _c(10);
  let extension;
  let passThroughProps;
  let value;
  if ($[0] !== t0) {
    var _t = t0;
    ({
      value,
      extension
    } = _t);
    passThroughProps = _objectWithoutPropertiesLoose(_t, _excluded);
    _t;
    $[0] = t0;
    $[1] = extension;
    $[2] = passThroughProps;
    $[3] = value;
  } else {
    extension = $[1];
    passThroughProps = $[2];
    value = $[3];
  }
  useContext(I18nHMRContext);
  let t1;
  if ($[4] !== extension || $[5] !== value) {
    t1 = extension ? formatPhoneNumberWithExtension(value, extension) : formatPhoneNumber(value);
    $[4] = extension;
    $[5] = value;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== passThroughProps || $[8] !== t1) {
    t2 = /*#__PURE__*/_jsx("span", Object.assign({}, passThroughProps, {
      children: t1
    }));
    $[7] = passThroughProps;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
FormattedPhoneNumber.displayName = 'FormattedPhoneNumber';
export default FormattedPhoneNumber;